
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.999 2C4.144 2 1.579 4.21.102 6.63a.726.726 0 00-.001.74C1.579 9.79 4.144 12 6.999 12c2.9 0 5.457-2.207 6.904-4.638a.725.725 0 000-.724C12.456 4.208 9.9 2 7 2zm5.889 5c-1.286 2.056-3.428 3.929-5.89 3.929-2.425 0-4.572-1.88-5.882-3.929 1.31-2.049 3.457-3.929 5.883-3.929 2.462 0 4.605 1.875 5.889 3.929zM7 4.143c1.546 0 2.8 1.28 2.8 2.857 0 1.577-1.254 2.857-2.8 2.857-1.546 0-2.8-1.28-2.8-2.857 0-1.577 1.254-2.857 2.8-2.857zm0 1.071c-.966 0-1.75.8-1.75 1.786S6.034 8.786 7 8.786 8.75 7.986 8.75 7 7.966 5.214 7 5.214z","fill":"#0085FF"}})])
          )
        }
      }
    